var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('measurements-index-list',{attrs:{"state":_vm.PersonMeasurements,"edit":_vm.edit,"period":_vm.period,"dateFrom":_vm.dateFrom,"dateTo":_vm.dateTo,"meta":_vm.meta}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63b079ae","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/professional/persons/participants/participant-evolution/dashboard/page-evolution-measurements-list.vue
// module id = 3139
// module chunks = 0